import dxBridge from "./dx-bridge"

export function getUserInfo(cb) {
    dxBridge.call('getUserInfo', {}, cb)
}

export function goPage(pageName) {
    dxBridge.call('goPage', { data: pageName })
}
goPage.PageName = {
    USERCENTER: 'usercenter',
    REGISTER: 'register',
    LOGIN: 'login',
    HOME: 'home',
}

export function recordPrepare(data, cb) {
    dxBridge.call('recordPrepare', { data }, cb)
}

export function recordEnd(cb) {
    dxBridge.call('recordEnd', {}, cb)
}

export function recordBreak() {
    dxBridge.call('recordBreak')
}

export function recordCancel(cb) {
    dxBridge.register('recordCancel', cb)
}

export function upload(data,cb){
    dxBridge.call('upload',data, cb)
}
export function hasNativeMethod(data,cb){
    dxBridge.call('hasNativeMethod',data, cb)
}